export default {
  register: {
    title: '创建新账户',
    subtitle: '欢迎使用我们的平台',
    emailRegister: '邮箱注册',
    phoneRegister: '手机号注册',
    email: '邮箱地址',
    phone: '手机号码',
    countryCode: '区号',
    phoneWithCode: '手机号码（含区号）',
    sendCode: '发送验证码',
    resendCode: '重新发送',
    countdown: '秒后重发',
    verificationCode: '验证码',
    emailVerificationCode: '邮箱验证码',
    phoneVerificationCode: '手机验证码',
    verificationCodePlaceholder: '请输入6位验证码',
    password: '密码',
    confirmPassword: '确认密码',
    captcha: '验证码',
    captchaPlaceholder: '请输入验证码',
    agreeTerms: '我同意',
    termsOfService: '服务条款',
    and: '和',
    privacyPolicy: '隐私政策',
    registerButton: '注册',
    registering: '注册中...',
    usernameRequired: '用户名不能为空',
    usernameMinLength: '用户名至少需要3个字符',
    emailRequired: '邮箱不能为空',
    emailInvalid: '请输入有效的邮箱地址',
    phoneRequired: '手机号不能为空',
    phoneInvalid: '请输入有效的手机号码',
    countryCodeRequired: '请选择区号',
    verificationCodeRequired: '请输入验证码',
    verificationCodeInvalid: '验证码错误，请重新输入',
    verificationCodeSent: '验证码已发送',
    verificationCodeSendFailed: '验证码发送失败，请重试',
    sending: '发送中...',
    passwordRequired: '密码不能为空',
    passwordMinLength: '密码至少需要6个字符',
    passwordMaxLength: '密码不能超过12个字符',
    passwordLowercaseRequired: '密码必须包含至少一个小写字母',
    passwordUppercaseRequired: '密码必须包含至少一个大写字母',
    confirmPasswordRequired: '请确认密码',
    passwordMismatch: '两次输入的密码不一致',
    inviteCode: '邀请码',
    inviteCodePlaceholder: '请输入邀请码',
    inviteCodeRequired: '邀请码不能为空',
    captchaRequired: '请输入验证码',
    captchaInvalid: '验证码错误，请重新输入',
    captchaError: '验证码加载失败',
    refreshCaptcha: '点击刷新验证码',
    sliderCaptchaInProgress: '正在进行滑块验证，请稍候...',
    sliderCaptchaSuccess: '滑块验证成功！',
    agreeTermsRequired: '请同意服务条款和隐私政策',
    becomeAgent: '成为代理',
    becomeAgentClicked: '代理申请功能开发中...',
    becomeAgentDescription: '选择成为代理可以获得更多权限和收益',
    agentBenefits: '代理特权',
    agentBenefitsList: '• 获得专属代理权限\n• 享受更高收益分成\n• 优先获得新功能体验\n• 专属客服支持',
    registerSuccess: '注册成功！',
    registerFailed: '注册失败，请重试',
    encryptionFailed: '密码加密失败，请重试',
    newUserReward: '新用户注册并充值200钻石以上，可获得100钻石'
  },
  download: {
    title: '恭喜注册成功',
    officialWebsite: '官网下载',
    scanToDownload: '扫描二维码立即体验'
  },
  promotion: {
    title: '邀请新朋友加入，共享钻石奖励',
    rule: '邀请好友注册并首次充值200石以上，邀请人和好友可以各获得100和200钻石奖励',
    loading: '加载中...',
    inviteButton: '去邀请',
    myRecords: '我的记录',
    totalInvited: '邀请总人数：{count}人',
    totalReward: '邀请总奖励：{count}钻石',
    inviteRecords: '邀请记录',
    rewardRecords: '奖励记录',
    registeredAndRecharged: '注册并首次充值',
    rewardForRegistration: '注册并首次充值奖励',
    userMasked: '用户***{mask}',
    statusRegistered: '已注册',
    statusRecharged: '已充值',
    statusPlayed: '已玩10局',
    noInviteRecords: '暂无邀请记录',
    noRewardRecords: '暂无奖励记录',
    inviteTitle: '邀请好友',
    inviteSubtitle: '分享邀请链接或邀请码给好友',
    inviteCode: '邀请码',
    inviteLink: '邀请链接',
    scanQRCode: '扫描二维码',
    shareLink: '分享链接',
    linkCopied: '链接已复制',
    codeCopied: '邀请码已复制',
    copySuccess: '复制成功',
    copyFailed: '复制失败，请手动复制',
    copyManually: '请手动复制以下内容：',
    clickOKToContinue: '点击确定继续',
    loadMore: '请求更多'
  },
  common: {
    logo: '应用标志',
    loading: '加载中...',
    error: '错误',
    success: '成功',
    cancel: '取消',
    confirm: '确认',
    save: '保存',
    edit: '编辑',
    delete: '删除',
    back: '返回',
    next: '下一步',
    previous: '上一步'
  },
  notFound: {
    title: '页面未找到',
    subtitle: '您访问的页面可能已被删除、名称已更改或暂时不可用。',
    goBack: '返回上页',
    goHome: '返回首页'
  },
  countries: {
    searchPlaceholder: '搜索国家/地区',
    china: '中国',
    usa: '美国',
    japan: '日本',
    korea: '韩国',
    uk: '英国',
    germany: '德国',
    france: '法国',
    canada: '加拿大',
    australia: '澳大利亚',
    singapore: '新加坡',
    hongKong: '香港',
    taiwan: '台湾',
    macau: '澳门',
    malaysia: '马来西亚',
    thailand: '泰国',
    vietnam: '越南',
    india: '印度',
    russia: '俄罗斯',
    brazil: '巴西',
    mexico: '墨西哥',
    italy: '意大利',
    spain: '西班牙',
    netherlands: '荷兰',
    switzerland: '瑞士',
    sweden: '瑞典',
    norway: '挪威',
    denmark: '丹麦',
    finland: '芬兰',
    poland: '波兰',
    czech: '捷克',
    hungary: '匈牙利',
    austria: '奥地利',
    belgium: '比利时',
    portugal: '葡萄牙',
    greece: '希腊',
    turkey: '土耳其',
    israel: '以色列',
    uae: '阿联酋',
    saudiArabia: '沙特阿拉伯',
    egypt: '埃及',
    southAfrica: '南非',
    nigeria: '尼日利亚',
    kenya: '肯尼亚',
    morocco: '摩洛哥',
    algeria: '阿尔及利亚',
    tunisia: '突尼斯',
    libya: '利比亚',
    sudan: '苏丹',
    ethiopia: '埃塞俄比亚',
    uganda: '乌干达',
    tanzania: '坦桑尼亚',
    ghana: '加纳',
    ivoryCoast: '科特迪瓦',
    senegal: '塞内加尔',
    mali: '马里',
    burkinaFaso: '布基纳法索',
    niger: '尼日尔',
    chad: '乍得',
    centralAfricanRepublic: '中非共和国',
    cameroon: '喀麦隆',
    gabon: '加蓬',
    congo: '刚果共和国',
    democraticRepublicOfCongo: '刚果民主共和国',
    angola: '安哥拉',
    guinea: '几内亚',
    sierraLeone: '塞拉利昂',
    liberia: '利比里亚',
    togo: '多哥',
    benin: '贝宁',
    mauritania: '毛里塔尼亚',
    gambia: '冈比亚',
    guineaBissau: '几内亚比绍',
    capeVerde: '佛得角',
    saoTomeAndPrincipe: '圣多美和普林西比',
    equatorialGuinea: '赤道几内亚',
    saintHelena: '圣赫勒拿',
    reunion: '留尼汪',
    mayotte: '马约特',
    comoros: '科摩罗',
    seychelles: '塞舌尔',
    mauritius: '毛里求斯',
    madagascar: '马达加斯加',
    malawi: '马拉维',
    zambia: '赞比亚',
    zimbabwe: '津巴布韦',
    botswana: '博茨瓦纳',
    namibia: '纳米比亚',
    lesotho: '莱索托',
    eswatini: '斯威士兰',
    mozambique: '莫桑比克',
    // 添加更多国家的翻译
    indonesia: '印度尼西亚',
    philippines: '菲律宾',
    cambodia: '柬埔寨',
    laos: '老挝',
    myanmar: '缅甸',
    mongolia: '蒙古',
    kazakhstan: '哈萨克斯坦',
    kyrgyzstan: '吉尔吉斯斯坦',
    tajikistan: '塔吉克斯坦',
    turkmenistan: '土库曼斯坦',
    uzbekistan: '乌兹别克斯坦',
    azerbaijan: '阿塞拜疆',
    georgia: '格鲁吉亚',
    armenia: '亚美尼亚',
    moldova: '摩尔多瓦',
    belarus: '白俄罗斯',
    ukraine: '乌克兰',
    romania: '罗马尼亚',
    bulgaria: '保加利亚',
    serbia: '塞尔维亚',
    croatia: '克罗地亚',
    slovenia: '斯洛文尼亚',
    slovakia: '斯洛伐克',
    estonia: '爱沙尼亚',
    latvia: '拉脱维亚',
    lithuania: '立陶宛',
    iceland: '冰岛',
    ireland: '爱尔兰',
    luxembourg: '卢森堡',
    // malta: '马耳他',
    cyprus: '塞浦路斯',
    qatar: '卡塔尔',
    bahrain: '巴林',
    kuwait: '科威特',
    oman: '阿曼',
    yemen: '也门',
    jordan: '约旦',
    lebanon: '黎巴嫩',
    syria: '叙利亚',
    iraq: '伊拉克',
    iran: '伊朗',
    afghanistan: '阿富汗',
    bhutan: '不丹',
    maldives: '马尔代夫',
    brunei: '文莱',
    eastTimor: '东帝汶',
    papuaNewGuinea: '巴布亚新几内亚',
    fiji: '斐济',
    vanuatu: '瓦努阿图',
    newCaledonia: '新喀里多尼亚',
    solomonIslands: '所罗门群岛',
    samoa: '萨摩亚',
    tonga: '汤加',
    cookIslands: '库克群岛',
    niue: '纽埃',
    tuvalu: '图瓦卢',
    kiribati: '基里巴斯',
    marshallIslands: '马绍尔群岛',
    micronesia: '密克罗尼西亚',
    palau: '帕劳',
    nauru: '瑙鲁',
    pitcairn: '皮特凯恩群岛',
    wallisAndFutuna: '瓦利斯和富图纳',
    frenchPolynesia: '法属波利尼西亚',
    americanSamoa: '美属萨摩亚',
    guam: '关岛',
    northernMarianaIslands: '北马里亚纳群岛',
    palestine: '巴勒斯坦',
    westernSahara: '西撒哈拉',
    southSudan: '南苏丹',
    eritrea: '厄立特里亚',
    djibouti: '吉布提',
    somalia: '索马里',
    rwanda: '卢旺达',
    burundi: '布隆迪',
    republicOfCongo: '刚果共和国',
    // 添加缺少的国家翻译
    sanMarino: '圣马力诺',
    bangladesh: '孟加拉国',
    bolivia: '玻利维亚',
    guatemala: '危地马拉',
    chile: '智利',
    elSalvador: '萨尔瓦多',
    nicaragua: '尼加拉瓜',
    peru: '秘鲁',
    honduras: '洪都拉斯',
    paraguay: '巴拉圭',
    venezuela: '委内瑞拉',
    colombia: '哥伦比亚',
    argentina: '阿根廷',
    ecuador: '厄瓜多尔',
    newZealand: '新西兰'
  }
}
